export const getAlerts = state => state.ui.alerts
export const getHeaderMode = state => state.ui.headerMode
export const getToolBarVisible = state => state.ui.toolbarVisible
export const getPopover = state => state.ui.popover
export const getPopoverIsOpened = state => state.ui.popover.isOpened
export const getPopOverName = state => state.ui.popover.name
export const getUploaderState = state => state.ui.upload
export const getToaster = state => state.ui.toaster
export const getContextMenu = state => state.ui.contextMenu
export const getForceUpdate = state => state.ui.forceupdate
export const getIsSaving = state => state.ui.saving
export const getSidebarOpened = state => state.ui.sidebar
export const getPageOrderOpened = state => state.ui.pageOrder
export const getFileManager = state => state.ui.fileManager
export const getLockBackground = state => state.ui.lockBackground
export const getZoom = state => state.ui.zoom
export const getZoomableInstance = state => state.ui.zoomableInstance



// WEBPACK FOOTER //
// ./src/store/getters/ui.js